import { render } from "./SecurityCheck.vue?vue&type=template&id=a9609782&scoped=true&ts=true"
import script from "./SecurityCheck.vue?vue&type=script&lang=ts"
export * from "./SecurityCheck.vue?vue&type=script&lang=ts"

import "./SecurityCheck.vue?vue&type=style&index=0&id=a9609782&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9609782"]])

export default __exports__